/*jshint esversion: 6 */
import {XhrService} from "../../../../default/global/ts/xhr.service";
import {
    addActionClass,
    addErrorClass,
    addLoadingClass,
    addSuccessClass
} from "../../../../default/global/js/utilities/updateClasses";

import {closeModal, showModal} from "../../../../default/global/js/modal";
import {setAccessibilityLiveRegionMessage} from "../../../../default/global/js/accessibilityLiveRegionService";

let favoriteModal;

function manageFavouritesShowModal(itemid, beforeSend, successSend, errorSend,trigger) {
    if (typeof beforeSend !== 'undefined') {
        beforeSend();
    }

    XhrService.generalAjaxCall('manage_favourites_show_modal', {item_id: itemid}, 'POST', 'json')
        .then(res => {
            if(favoriteModal){
                favoriteModal.remove();
            }
            const modalDoc = new DOMParser().parseFromString(res.modal, "text/html");
            const modal = modalDoc.body.firstElementChild;
            document.body.appendChild(modal);
            favoriteModal = document.querySelector("#favorites-select");
            showModal(favoriteModal,null,{modalTrigger: trigger});
        });
}

function assignItemToFavorite(itemid,
                              favoriteHeaderids,
                              createNewHeader,
                              newHeaderName,
                              successSend, errorSend) {
    XhrService.generalAjaxCall('manage_favourites_save', {
        item_id: itemid,
        favorite_header_ids: favoriteHeaderids,
        create_new_header: createNewHeader,
        new_header_name: newHeaderName
    }, 'POST', 'json')
        .then(res => {
            // if (res.success) {
            //ToastService.showToast('success', 'GeneralAjaxData works successfully',100000);
            updateFavoritesCount(res.favouriteCount);
            setAccessibilityLiveRegionMessage(GLOBALS.tc.addedToFavorites, "assertive");

            let removeFromFavouriteIcons = document.getElementsByClassName('js-removeFromFavorites');
            for (let spanIcon of removeFromFavouriteIcons) {
                if (spanIcon.dataset.id === itemid) {
                    if (res.itemFavoiriteClass === 'icon-favorites') {
                        spanIcon.classList.remove('js-removeFromFavorites');
                        spanIcon.classList.add('js-addToFavorites');

                        let icon = spanIcon.querySelector('.icon');
                        if (icon) {
                            icon.classList.remove('icon-favorites-filled');
                            icon.classList.add('icon-favorites');
                        }
                    }
                }
            }

            let addToFavouriteIcons = document.getElementsByClassName('js-addToFavorites');
            for (let spanIcon of addToFavouriteIcons) {
                if (spanIcon.dataset.id === itemid) {
                    if (res.itemFavoiriteClass === 'icon-favorites-filled') {
                        spanIcon.classList.remove('js-addToFavorites');
                        spanIcon.classList.add('js-removeFromFavorites');

                        let icon = spanIcon.querySelector('.icon');
                        if (icon) {
                            icon.classList.remove('icon-favorites');
                            icon.classList.add('icon-favorites-filled');
                        }
                    }
                }
            }
            if (typeof successSend !== 'undefined') {
                successSend(res);
            }

        }, err => {
            console.error(err);
            if (typeof errorSend !== 'undefined') {
                errorSend();
            }
        });


}

function updateFavoritesCount(currentCount) {
    for (let count of document.querySelectorAll('.js-favoritesCount')) {
        count.innerHTML = currentCount;
        if (parseInt(count.innerHTML) === 0) {
            count.style.display = "none";
        } else {
            addActionClass(count, function () {
                count.style.display = "";
            });
        }
    }
}

function toggleFavoriteBtnClasses(el) {
    let icon = el.querySelector('.icon');
    let filledIconClass = 'icon-favorites-filled';
    let emptyIconClass = 'icon-favorites';
    if (el.classList.contains("js-addToFavorites")) {
        el.classList.remove("js-addToFavorites");
        el.classList.add("js-removeFromFavorites");

        if (icon) {
            icon.classList.remove(emptyIconClass);
            icon.classList.add(filledIconClass);
        }
    } else {
        el.classList.remove("js-removeFromFavorites");
        el.classList.add("js-addToFavorites");

        if (icon) {
            icon.classList.remove(filledIconClass);
            icon.classList.add(emptyIconClass);
        }
    }
}

export function triggerFavoritesBtns() {
    document.addEventListener("click", function (e) {
        let target = e.target;

        if (target.closest(".js-addToFavorites")) {
            let itemID = target.dataset.id;
            if (itemID) {
                manageFavouritesShowModal(itemID, () => {
                    },
                    (result) => {
                        if (result.success) {
                            toggleFavoriteBtnClasses(target);
                        } else {
                            addErrorClass(target);
                        }
                    }, () => {
                        addErrorClass(target);
                    },target);
            } else {
                console.error("item id not found");
            }
            e.preventDefault();
        }

        if (target.closest(".js-removeFromFavorites")) {
            const itemID = target.dataset.id;
            if (itemID) {
                manageFavouritesShowModal(itemID, () => {
                    },
                    (result) => {
                        if (result.success) {
                            toggleFavoriteBtnClasses(target);
                        } else {
                            addErrorClass(target);
                        }
                    }, () => {
                        addErrorClass(target);
                    },target);
            } else {
                console.error("item id not found");
            }
            e.preventDefault();
        }

        if (target.closest('.button-favourite-save')) {
            let modal = target.closest('.modal__dialog');
            let itemId = modal.querySelector('.js-multifavorites-item-id').value;

            let checkboxes = modal.querySelectorAll('.js-multifavorites-addlist:checked');
            let favoriteHeaderIds = [];

            let createNewHeader = modal.querySelector('.js-multifavorites-create-header:checked');
            let newHeaderName = modal.querySelector('.js-multifavorites-create-header-input').value;

            if(createNewHeader && createNewHeader.checked) {
                createNewHeader = true;
            }

            if (newHeaderName.length > 0 && !createNewHeader) {
                createNewHeader = true;
                modal.querySelector('.js-multifavorites-create-header').checked = true;
            }

            for (let checkbox of checkboxes) {
                let checkboxHeaderId = checkbox.getAttribute('data-header-id');
                favoriteHeaderIds.push(checkboxHeaderId);
            }

            assignItemToFavorite(
                itemId,
                favoriteHeaderIds,
                createNewHeader,
                newHeaderName, () => {
                    closeModal(favoriteModal);
                }, () => {
                    closeModal(favoriteModal);
                });

        }
    });

}

/**
 * Initialize add and edit modal for list
 * it hacky because we use one modal/form for adding and editing
 */
export function initButtonFavouritesView() {
    /**
     * Check if edit/add modal is presented and move it to correct position for modal intializiation
     */
    let modal = document.querySelector(".js-edit-header-modal");
    let elModalTitle ;
    if (modal) {
        document.body.appendChild(modal);
        elModalTitle=modal.querySelector(".js-edit-header-modal-title");
    } else {
        return;
    }

    let addFavouriteHeader = document.getElementsByClassName('add-header');
    if (addFavouriteHeader.length > 0) {
        addFavouriteHeader[0].addEventListener('click', function (event) {
            elModalTitle.innerHTML = elModalTitle.dataset.titleNew;
            let headerIdInput = modal.querySelector('input[name="header_id"]');
            let descriptionInput = modal.querySelector('input[name="description"]');
            if (headerIdInput) {
                headerIdInput.value = 0;
            }
            if (descriptionInput) {
                descriptionInput.value = "";
            }
            showModal(modal);
        });
    }

    //Edit existing
    let editButtonsOnFavouriteLists = document.getElementsByClassName('js-edit-favorite-header');
    if (editButtonsOnFavouriteLists.length > 0) {
        for (let i = 0; i < editButtonsOnFavouriteLists.length; i++) {
            editButtonsOnFavouriteLists[i].addEventListener('click', function (event) {
                event.preventDefault();
                elModalTitle.innerHTML = elModalTitle.dataset.titleEdit;
                let headerId = this.getAttribute('data-header-id');
                let headerDescription = this.getAttribute('data-header-description');
                let headerIdInput = modal.querySelector('input[name="header_id"]');
                let descriptionInput = modal.querySelector('input[name="description"]');
                if (headerIdInput) {
                    headerIdInput.value = headerId;
                }
                if (descriptionInput) {
                    descriptionInput.value = headerDescription;
                }
                showModal(modal);
            });
        }
    }

}